// translations.js
// Full AR / EN translation map for NexusFlow dashboard nav_dashboard:

const translations = {
  en: {
    // ─── Brand ───────────────────────────────────────────────
    brand: "NexusFlow",

    footer_copyright: "© ALVRA. All rights reserved. Intellectual Property registered in KSA.",


    // ─── Plan highlights ──────────────────────────────────────
plan_highlight_evals_50: "50 campaign evaluations/month",
plan_highlight_evals_500: "500 campaign evaluations/month",
plan_highlight_evals_unlimited: "Unlimited campaign evaluations",
plan_highlight_campaigns_3: "Up to 3 campaigns",
plan_highlight_campaigns_25: "Up to 25 campaigns",
plan_highlight_campaigns_unlimited: "Unlimited campaigns",
plan_highlight_shares_10: "10 share links",
plan_highlight_shares_100: "100 share links",
plan_highlight_shares_unlimited: "Unlimited share links",
plan_highlight_mode_balanced_only: "Balanced decision mode only",
plan_highlight_all_modes: "All decision modes",
plan_highlight_pdf_200: "PDF export (200/month)",
plan_highlight_pdf_unlimited: "Unlimited PDF exports",
plan_highlight_analytics: "Analytics dashboard",
plan_highlight_api_access: "API access",
plan_highlight_custom_branding: "Custom branding",
plan_highlight_bilingual: "Bilingual support (EN/AR)",
plan_highlight_email_support: "Email support",
plan_highlight_priority_support: "Priority support",
plan_highlight_account_manager: "Dedicated account manager",
free_plan_desc: "Perfect for trying out NexusFlow",
pro_plan_desc: "For growing marketing teams",
enterprise_plan_desc: "For large organizations",

    // ─── Product Dashboard ────────────────────────────────────
status_critical: "Critical",
status_opportunity: "Opportunity",
status_stable: "Stable",
price_value_high: "High",
price_value_medium: "Medium",
price_value_low: "Low",
indicator_high: "High",
indicator_medium: "Medium",
indicator_low: "Low",
rule_reason_low_sales_high_stock: "Low sales with high inventory indicates potential loss",
rule_reason_high_demand_low_stock: "High demand with low stock risks stockout",
rule_reason_strong_sales_high_price: "Strong sales despite high price",
rule_reason_balanced: "Balanced demand and inventory",
rule_reason_no_match: "No specific rule matched",
rule_action_reduce_price: "Reduce price or increase promotion",
rule_action_refill_inventory: "Refill inventory urgently",
rule_action_maintain_price: "Maintain price or test slight increase",
rule_action_no_action: "No action required",


    // English (en)
role_owner: "Owner",
role_admin: "Admin",
role_manager: "Manager",
role_member: "Member",



    decision_continue: "Continue",
decision_pause: "Pause",
decision_stop: "Stop",
channel_tiktok: "TikTok",
channel_snapchat: "Snapchat",
channel_google: "Google",
channel_meta: "Meta",
channel_other: "Other",


    plan_free: "Free",
plan_pro: "Pro",
plan_enterprise: "Enterprise",
    // ─── Navigation ──────────────────────────────────────────
    nav_dashboard: "Products",
    nav_products: "Products",
    nav_campaign_decision: "Campaigns Decision",
    nav_admin: "Admin",
    nav_logout: "Logout",

    // ─── Language toggle ─────────────────────────────────────
    lang_toggle: "عربي",          // label shown when current = EN (switch to AR)
    lang_current: "EN",

    // ─── Common actions ──────────────────────────────────────
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    back: "Back",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    try_again: "Try Again",
    close: "Close",
    search: "Search...",
    view: "View",
    share: "Share",
    download_pdf: "Download PDF",
    upgrade: "Upgrade",
    upgrade_plan: "Upgrade Plan",
    not_available: "Not available on your plan",
    upgrade_to_unlock: "Upgrade to unlock",
    contact_support: "Contact support",
    no_data: "No data found",

    // ─── Status / Decision labels ─────────────────────────────
    status_stable: "Stable",
    status_opportunity: "Opportunity",
    status_critical: "Critical",
    status_warning: "Warning",
    status_active: "Active",
    status_suspended: "Suspended",
    status_pending: "Pending Evaluation",

    // ─── Profile page ────────────────────────────────────────
    profile_title: "My Profile",
    profile_subtitle: "Update your personal information and password",
    profile_personal_info: "Personal Information",
    profile_security: "Security",
    profile_display_name: "Display Name",
    profile_email: "Email",
    profile_email_locked_hint: "Email changes are not available yet",
    profile_role: "Role",
    profile_company: "Company",
    profile_current_password: "Current Password",
    profile_new_password: "New Password",
    profile_confirm_password: "Confirm New Password",
    profile_save: "Save Changes",
    profile_change_password: "Change Password",
    profile_password_hint: "Leave blank to keep your current password",
    profile_password_mismatch: "Passwords do not match",
    profile_password_too_short: "Password must be at least 8 characters",
    profile_saved: "Profile updated successfully",
    profile_password_changed: "Password changed successfully",
    profile_reauth_required: "Please sign in again before changing your password",
    profile_no_changes: "No changes to save",
    profile_link: "Profile",

    // ─── Admin: tenant CRUD ──────────────────────────────────
    admin_add_tenant: "Add Company",
    admin_edit_tenant: "Edit Company",
    admin_delete_tenant: "Delete Company",
    admin_tenant_company_name: "Company Name",
    admin_tenant_owner_name: "Owner Name",
    admin_tenant_owner_email: "Owner Email",
    admin_tenant_owner_password: "Initial Password",
    admin_tenant_business_type: "Business Type",
    admin_tenant_plan: "Plan",
    admin_tenant_status: "Status",
    admin_create: "Create",
    admin_save: "Save",
    admin_cancel: "Cancel",
    admin_delete_warning: "This will permanently delete the company and all of its data — campaigns, decisions, share links, and users. This cannot be undone.",
    admin_delete_confirm_label: "Type the company name to confirm",
    admin_tenant_created: "Company created successfully",
    admin_tenant_updated: "Company updated successfully",
    admin_tenant_deleted: "Company deleted successfully",

    decision_continue: "CONTINUE",
    decision_adjust: "ADJUST",
    decision_stop: "STOP",

    // ─── Theme ───────────────────────────────────────────────
    theme_dark: "Dark",
    theme_light: "Light",
    view_cards: "Cards",
    view_table: "Table",
    rules_engine_active: "Rules Engine Active",

    // ─── Login / Register ─────────────────────────────────────
    sign_in: "Sign In",
    register: "Register",
    sign_in_to_account: "Sign in to your account",
    create_company_account: "Create your company account",
    email: "Email",
    password: "Password",
    confirm_password: "Confirm Password",
    your_name: "Your Name",
    company_name: "Company Name",
    business_type: "Business Type",
    business_type_agency: "Marketing Agency",
    business_type_store: "E-commerce Store",
    business_type_service: "Service Business",
    select_business_type: "Select business type...",
    passwords_no_match: "Passwords do not match",
    creating_account: "Creating account...",
    signing_in: "Signing in...",
    already_have_account: "Already have an account?",
    no_account_yet: "Don't have an account?",
    register_company: "Register your company",
    min_password: "At least 6 characters",
    business_type_hint_agency: "Track client campaigns and ROI",
    business_type_hint_store: "Monitor products and profit margins",
    business_type_hint_service: "Manage leads and conversions",
    login_invalid: "Invalid email or password",
    login_not_found: "No account found with this email",
    login_failed: "Failed to sign in. Please try again.",
    register_failed: "Registration failed. Please try again.",

    // ─── Dashboard (Products) ─────────────────────────────────
    dashboard_title: "Products Intelligence",
    dashboard_subtitle: "Real-time product analysis",
    performance_overview: "Performance Overview",
    total_products: "Total Products",
    all_time: "All Time",
    high_growth_potential: "High growth potential",
    requires_attention: "Requires attention",
    filter_all: "All",
    filter_stable: "Stable",
    filter_opportunity: "Opportunity",
    filter_critical: "Critical",
    search_products: "Search products...",
    no_products_found: "No products match your search",
    no_products_yet: "No products found",
    confidence: "Confidence",
    action: "Action",
    reason: "Reason",
    avg_confidence: "Avg. Confidence",
    total_sales: "Total Sales",
    total_stock: "Total Stock",
    sales: "Sales",
    stock: "Stock",
    price: "Price",
    price_high: "High",
    price_medium: "Medium",
    price_low: "Low",
    sales_high: "High",
    sales_medium: "Medium",
    sales_low: "Low",
    stock_high: "High",
    stock_medium: "Medium",
    stock_low: "Low",

    // ─── Usage widget ─────────────────────────────────────────
    usage_this_month: "Usage This Month",
    campaign_evaluations: "Campaign Evaluations",
    unlimited_evaluations: "Unlimited evaluations",
    evaluations_available: "evaluations available this month",
    almost_at_limit: "You're almost at your limit! Consider upgrading.",
    approaching_limit: "You're approaching your monthly limit.",
    view_plans: "View Plans",
    shares_created: "Shares Created",
    pdfs_generated: "PDFs Generated",

    // ─── Campaign Decision ────────────────────────────────────
    campaign_decision: "Campaign Decision",
    campaign_decision_ar: "قرار الحملة",
    campaigns: "Campaigns",
    new_campaign: "New Campaign",
    create_campaign: "Create Campaign",
    campaign_name: "Campaign Name",
    campaign_name_placeholder: "e.g., Summer Sale 2024",
    channel: "Channel",
    select_channel: "Select a channel",
    specify_channel: "Specify the channel",
    specify_channel_placeholder: "e.g. LinkedIn, X, YouTube...",
    no_campaigns_yet: "No Campaigns Yet",
    no_campaigns_desc: "Create your first campaign to start tracking and evaluating performance",
    create_first_campaign: "Create Your First Campaign",
    total_campaigns: "Total Campaigns",
    active_campaigns: "Active Campaigns",
    evaluated_this_month: "Evaluated This Month",
    delete_campaign_confirm: "Are you sure you want to delete",
    delete_campaign_warning: "This cannot be undone.",
    campaign_deleted: "has been deleted successfully!",
    campaign_delete_failed: "Failed to delete campaign: ",
    evaluations: "Evaluations",
    latest_decision: "Latest Decision",
    created: "Created",
    loading_campaigns: "Loading campaigns...",

    // ─── Campaign Detail ──────────────────────────────────────
    back_to_campaigns: "Back to Campaigns",
    evaluate_campaign: "Evaluate Campaign",
    total_evaluations: "Total Evaluations",
    decision_history: "Decision History",
    no_evaluations_yet: "No evaluations yet",
    evaluate_this_campaign: "Evaluate This Campaign",
    loading_campaign: "Loading campaign...",
    campaign_not_found: "Campaign not found",

    // ─── Evaluate Modal ───────────────────────────────────────
    evaluate_campaign_title: "Evaluate Campaign",
    decision_mode: "Decision Mode",
    decision_mode_fixed: "Fixed on current plan",
    decision_mode_conservative: "Conservative",
    decision_mode_balanced: "Balanced",
    decision_mode_aggressive: "Aggressive",
    decision_mode_balanced_fixed: "Balanced (Fixed)",
    mode_conservative_desc: "Prioritizes protecting budget. Only continues campaigns with proven strong performance.",
    mode_balanced_desc: "Balanced approach. Weighs both risk and opportunity equally.",
    mode_aggressive_desc: "Growth-focused. More willing to continue campaigns with potential despite current metrics.",
    mode_locked_msg: "Mode selection is not available on your current plan.",
    evaluation_period: "Evaluation Period (Days)",
    evaluation_period_hint: "Number of days this campaign has been running",
    campaign_metrics: "Campaign Metrics",
    ad_spend: "Ad Spend ",
    ad_spend_placeholder: "e.g., 1500.00",
    revenue: "Revenue Generated ",
    revenue_placeholder: "e.g., 4500.00",
    target_roas: "Target ROAS (optional)",
    impressions: "Impressions (Optional)",
    impressions_placeholder: "e.g., 50000",
    clicks: "Clicks (Optional)",
    clicks_placeholder: "e.g., 2500",
    units_sold: "Units Sold (Optional)",
    units_sold_placeholder: "e.g., 120",
    profit_margin: "Profit Margin % (Optional)",
    fees: "Fees (Optional)",
    shipping: "Shipping (Optional)",
    returns_pct: "Returns % (Optional)",
    leads: "Leads Generated",
    conversions: "Conversions (Optional)",
    leads_placeholder: "e.g., 85",
    conversions: "Conversions",
    conversions_placeholder: "e.g., 23",
    conversion_pct: "Conversion %",
    avg_ticket: "Avg. Ticket Value",
    service_cost: "Service Cost (Optional)",
    run_decision: "Run Decision",
    evaluating: "Evaluating...",

    // ─── Decision Result ──────────────────────────────────────
    key_performance: "Key Performance Indicators",
    analysis: "Analysis",
    recommended_actions: "Recommended Actions",
    next_review: "Recommended next review:",
    days: "days",
    share_decision: "Share Decision",
    share_locked: "Share links are not available on your current plan.",
    pdf_locked: "PDF export is not available on your current plan.",
    share_upgrade_required: "Share (Upgrade Required)",
    pdf_upgrade_required: "PDF (Upgrade Required)",

    // ─── Share Modal ──────────────────────────────────────────
    create_public_link: "Create a public link to share this result",
    link_expiration: "Link Expiration",
    generating: "Generating...",
    generate_link: "Generate Link",
    share_link: "Share Link",
    copied: "Copied to clipboard!",
    expires_on: "Expires on:",
    share_with: "Share this link with:",
    done: "Done",
    never_expires: "Never expires",

    // ─── Plans ───────────────────────────────────────────────
    plans_title: "Plans & Pricing",
    plans_subtitle: "Choose the perfect plan for your business needs",
    current_plan_label: "Current Plan",
    current_usage: "Current Usage",
    per_month: "/month",
    upgrade_to: "Upgrade to",
    downgrade_to: "Downgrade to",
    select_plan: "Select",
    current_plan: "Current Plan",
    processing: "Processing...",
    evaluations_quota: "Evaluations",
    campaigns_quota: "Campaigns",
    share_links_quota: "Share Links",
    pdf_quota: "PDF Exports",
    unlimited: "Unlimited",
    not_included: "Not included",
    plan_free: "Free",
    plan_pro: "Pro",
    plan_enterprise: "Enterprise",
    need_help_plan: "Need help choosing a plan?",
    free_plan_desc: "Perfect for testing NexusFlow and evaluating a few campaigns. Great for freelancers and small projects.",
    pro_plan_desc: "Ideal for growing teams managing multiple campaigns. Includes advanced features and higher limits.",
    enterprise_plan_desc: "Built for large organizations with high-volume needs. Unlimited usage and premium support.",
    billing_note: "In this MVP version, plan changes are manual. Contact admin to process payment and activate your new plan.",
    questions: "Questions?",
    most_popular: "Most Popular",
    change_plan_confirm: "Are you sure you want to change to the",
    plan_label: "plan?",
    loading_plans: "Loading plans...",

    // ─── Upgrade CTA ─────────────────────────────────────────
    limit_reached: "Limit Reached",
    not_available_plan: "Not Available",
    almost_at_feature_limit: "Almost at",
    limit_suffix: "Limit",
    upgrade_to_continue: "Upgrade to Continue",
    upgrade_to_unlock: "Upgrade to Unlock",
    upgrade_now: "Upgrade Now",
    not_now: "Not Now",
    recommended_for_you: "Recommended for you:",
    exceeded: "Exceeded",
    warning_status: "Warning",
    quota_exceeded_hint: "Quota exceeded. Upgrade your plan to continue.",
    remaining_hint: "remaining. Consider upgrading.",

    // ─── Admin Dashboard ──────────────────────────────────────
    admin_title: "System Admin",
    admin_subtitle: "NexusFlow Management",
    total_tenants: "Total Tenants",
    total_users: "Total Users",
    suspended_count: "Suspended",
    tab_tenants: "Tenants",
    tab_users: "Users",
    col_company: "Company",
    col_status: "Status",
    col_users: "Users",
    col_api_key: "API Key",
    col_actions: "Actions",
    col_user: "User",
    col_role: "Role",
    no_tenants: "No tenants found. Register a company to get started.",
    no_users: "No users found.",
    action_suspend: "Suspend",
    action_activate: "Activate",
    action_regen_key: "Regenerate API Key",
    action_change_plan: "Change Plan",
    current_plan_prompt: "Current:",
    select_new_plan: "Select new plan:\n- plan_trial\n- plan_basic\n- plan_pro\n- plan_enterprise\n\nType the plan ID:",
    plan_updated: "Plan updated to",
    plan_update_failed: "Error: ",
    role_owner: "Owner",
    role_admin: "Admin",
    role_manager: "Manager",
    role_viewer: "Viewer",
    role_member: "Member",

    // ─── Tenant Features (Admin) ──────────────────────────────
    tenant_features_title: "Tenant Feature Management",
    tenant_features_subtitle: "Manage feature flags and access controls per tenant",
    select_tenant: "Select Tenant",
    select_tenant_hint: "Select a tenant to manage features",
    feature_flags: "Feature Flags & Access Control",
    section_core: "Core Features",
    section_modes: "Decision Modes",
    section_languages: "Languages",
    section_limits: "Limits & Access",
    section_advanced: "Advanced Features",
    feature_campaign_decision: "Campaign Decision Module",
    feature_campaign_decision_desc: "Enable/disable the entire campaign decision module",
    feature_share: "Share Links",
    feature_share_desc: "Allow creating and sharing decision links",
    feature_pdf: "PDF Export",
    feature_pdf_desc: "Enable PDF download for decisions",
    feature_analytics: "Analytics Dashboard",
    feature_analytics_desc: "Access to analytics and insights",
    feature_mode_selection: "Allow Mode Selection",
    feature_mode_selection_desc: "Users can choose between Conservative/Balanced/Aggressive. If disabled, defaults to Balanced.",
    allowed_modes: "Allowed Modes",
    enabled_languages: "Enabled Languages",
    max_users: "Maximum Users",
    max_users_hint: "Number of users allowed in this tenant",
    feature_api_access: "API Access",
    feature_api_access_desc: "Enable API key access for this tenant",
    feature_export: "Data Export",
    feature_export_desc: "Allow exporting campaign data",
    feature_custom_branding: "Custom Branding",
    feature_custom_branding_desc: "Allow custom logo and colors",
    save_changes: "Save Changes",
    saving: "Saving...",
    save_all: "Save All Changes",
    features_updated: "Features updated successfully!",
    features_failed: "Failed to save features",
    enabled_label: "Enabled",
    disabled_label: "Disabled",

    // ─── Public Share ─────────────────────────────────────────
    share_page_title: "NexusFlow Decision",
    share_page_subtitle: "Campaign Evaluation Report",
    get_nexusflow: "Get NexusFlow",
    link_invalid: "Link Not Available",
    link_invalid_desc: "This share link is invalid or has expired",
    link_expired_desc: "This share link has expired",
    link_load_failed: "Failed to load decision",
    performance_metrics: "Performance Metrics",
    generated_on: "Generated on",
    try_nexusflow: "Want AI-powered campaign decisions for your business?",
    try_free: "Try NexusFlow Free",

    // ─── Feature locked (Campaigns) ──────────────────────────
    campaign_locked_title: "Campaign Decision Module Not Available",
    campaign_locked_desc: "This powerful feature is not included in your current plan. Upgrade to unlock AI-powered campaign decisions and analytics.",
    campaign_locked_feature_1: "AI-powered campaign performance analysis",
    campaign_locked_feature_2: "Automated Continue/Pause/Stop recommendations",
    campaign_locked_feature_3: "Real-time KPI tracking and insights",
    campaign_locked_feature_4: "Multi-channel campaign management",
    what_youll_get: "What you'll get with an upgrade:",

    // ─── Account suspended ────────────────────────────────────
    account_suspended: "Account Suspended",
    account_suspended_desc: "Your company account has been suspended. Please contact support for assistance.",
    company_label: "Company:",

    // ─── Auth / Route guards ──────────────────────────────────
    checking_auth: "Checking authentication...",
    admin_required: "Admin Access Required",
    admin_required_desc: "You don't have permission to access this page.",
    go_to_dashboard: "Go to Dashboard",
    loading_user: "Loading user data...",
    please_wait: "Please wait",
    tenant_not_found: "Your account is not associated with a tenant. Please contact support.",

    // ─── Dashboard / Products ─────────────────────────────────
    performance_overview: "Performance Overview",
    performance_summary: "Performance Summary",
    based_on_all_metrics: "Based on all metrics",
    total_products: "Total Products",
    all_time: "All Time",
    growth_last_month: "+12% from last month",
    high_growth_potential: "High growth potential",
    requires_attention: "Requires attention",
    avg_confidence: "Avg. Confidence",
    ai_prediction_accuracy: "AI prediction accuracy",
    confidence_low: "Low",
    confidence_high: "High",
    confidence_excellent: "Excellent",
    confidence_good: "Good",
    confidence_needs_improvement: "Needs Improvement",
    confidence_growth: "+3.2% this month",
    perf_strong: "Strong",
    perf_moderate: "Moderate",
    perf_weak: "Weak",

    // ─── Controls ─────────────────────────────────────────────
    all_products: "All Products",
    search_products: "Search products...",

    // ─── Product cards / table ────────────────────────────────
    sales_label: "Sales",
    stock_label: "Stock",
    price_label: "Price",
    col_product: "Product",
    confidence: "confidence",
    rule_confidence: "Rule Confidence",
    recommended_action: "Recommended Action",
    no_products_found: "No products found",
    adjust_filters: "Try adjusting your filters or search query",
    indicator_high: "High",
    indicator_medium: "Medium",
    indicator_low: "Low",
    price_high: "High",
    price_medium: "Medium",
    price_low: "Low",

    // ─── Footer ───────────────────────────────────────────────
    rules_engine_active: "Rules Engine Active",
    products_analyzed: "Products Analyzed",

    // ─── Plan card ────────────────────────────────────────────
    most_popular: "Most Popular",
    current_plan_badge: "Current Plan",
    month: "month",
    upgrade_to: "Upgrade to",
    downgrade_to: "Downgrade to",
    select_plan_btn: "Select",
    processing: "Processing...",
    not_included: "Not included",

    // ─── Usage progress ───────────────────────────────────────
    of: "of",
    quota_exceeded: "Exceeded",
    quota_warning: "Warning",
    quota_exceeded_msg: "Quota exceeded. Upgrade your plan to continue.",
    quota_remaining_msg: "remaining. Consider upgrading.",

    // ─── Feature flag toggle ──────────────────────────────────
    feature_enabled: "Enabled",
    feature_disabled: "Disabled",

    // ─── Week 2: Company Dashboard ────────────────────────────
    nav_company: "Home",
    company_dashboard: "Company Dashboard",
    welcome_back: "Welcome back",
    role_label: "Role",
    refresh: "Refresh",
    recent_activity: "Recent Activity",
    no_recent_activity: "No decisions yet. Run your first campaign evaluation to see activity here.",
    go_to_campaigns: "Go to Campaigns",
    decision_breakdown: "Decision Breakdown",
    based_on_label: "Based on last",
    decisions_label: "decisions",
    continue_decisions: "Continue Decisions",
    evaluations_this_month: "Evaluations This Month",
    last_10_decisions: "from last 10 decisions",
    plan_label: "Plan",
    total_evals_label: "total evaluations",
    of_label: "of",
    active_label: "active",
    your_campaigns: "Your Campaigns",
    more_campaigns: "more campaigns",
    view_all: "View All",
    quick_actions: "Quick Actions",
    manage_team: "Manage Team",


    decision_label_continue: "CONTINUE",
decision_label_adjust:   "ADJUST",
decision_label_stop:     "STOP",

status_label_active:      "Active",
status_label_suspended:   "Suspended",
status_label_critical:    "Critical",
status_label_stable:      "Stable",
status_label_opportunity: "Opportunity",
status_label_warning:     "Warning",


    // ─── Week 2: Campaigns page fixes ─────────────────────────
    campaigns_subtitle: "Track, evaluate and optimize your marketing campaigns",
    campaigns_label: "campaigns",
    search_campaigns_placeholder: "Search campaigns by name...",
    clear_filters: "Clear filters",
    no_campaigns_match: "No campaigns match your current filters.",
    create_campaign_subtitle: "Set up a new campaign to start tracking performance",
    sort_newest: "Newest first",
    sort_oldest: "Oldest first",
    sort_most_evals: "Most evaluations",
    sort_last_decision: "Last decision",
    all_label: "All",
    decision_continue: "Continue",
    decision_pause: "Pause",
    decision_stop: "Stop",

    // ─── Week 2: Evaluate modal fixes ─────────────────────────
    auto_detected_label: "auto-detected",
    change_business_type: "Change business type",
    select_business_type_hint: "Choose the type that best describes your business model:",
    error_cost_required: "Ad spend is required and must be greater than 0.",
    error_revenue_required: "Revenue is required and must be greater than 0.",
    error_leads_conversions_required: "Both leads and conversions are required.",
    error_conversions_exceed_leads: "Conversions cannot exceed the number of leads.",
    roas_formula_hint: "Revenue ÷ Ad Spend. A ROAS of 3x means SAR3 earned per SAR1 spent.",
    profit_formula_hint: "Revenue × Margin% − Ad Spend",
    profit_margin_hint: "Enter as a percentage, e.g. 35 for 35%",
    cpl_formula_hint: "Ad Spend ÷ Leads. Lower is better.",
    conv_rate_formula_hint: "Conversions ÷ Leads × 100%",

    // ─── Week 3: Decision Result + History ────────────────────
    history_empty_hint: "Run your first evaluation to start building decision history.",
    no_history_filter_match: "No decisions match the selected filter.",
    load_more: "Load more",
    remaining: "remaining",
    status_updated: "Status updated",
    key_regenerated: "API key regenerated",

    // ─── Week 3: Admin feature-flag dynamic label keys ─────────
    campaign_decision_enabled: "Campaign Decision",
    share_enabled:             "Share Links",
    pdf_enabled:               "PDF Export",
    analytics_enabled:         "Analytics",
    decision_mode_enabled:     "Decision Mode",
    api_access_enabled:        "API Access",
    export_enabled:            "Data Export",
    custom_branding_enabled:   "Custom Branding",

    // ─── Week 3: misc ─────────────────────────────────────────
    all:    "All",
    active: "Active",

    // ─── Week 4: Roles ────────────────────────────────────────
    role_superadmin:    "Super Admin",
    change_role:        "Change Role",
    role_changed:       "Role updated successfully",
    permission_denied:  "Access Denied",
    back_to_dashboard:  "Back to Dashboard",
    viewer_no_access:   "You don't have permission to access this page.",

    // ─── Week 4: PDF ──────────────────────────────────────────
    generating_pdf:     "Generating…",
    pdf_error:          "PDF generation failed. Please try again.",

    // ─── Navigation / Footer ──────────────────────────────────
    footer_powered: "Powered by NexusFlow",
    footer_rules: "Rule-based AI analysis",
    footer_realtime: "Real-time insights",
    footer_decisions: "Smart decisions",

    // ─── Admin ────────────────────────────────────────────────
    admin_title: "System Admin",
    tenants: "Tenants",
    users: "Users",
    user: "User",
    role: "Role",
    total_tenants: "Total Tenants",
    total_users: "Total Users",
    suspended: "Suspended",
    activate: "Activate",
    suspend: "Suspend",
    col_company: "Company",
    col_status: "Status",
    col_actions: "Actions",
    no_tenants: "No tenants found. Register a company to get started.",
    no_users: "No users found.",
    regenerate_key: "Regenerate API Key",
    change_plan: "Change Plan",
    confirm_plan_change: "Are you sure you want to change to the",
    type_plan_id: "Type the plan ID",
    select_plan: "Select new plan",

    // ─── Tenant Features ──────────────────────────────────────
    tenant_features: "Tenant Feature Flags",
    tenant_features_desc: "Control which features are enabled per tenant",
    feature_flags: "Feature Flags & Access Control",
    features_saved: "Features updated successfully!",
    select_tenant_prompt: "Select a tenant from the list to manage their features",
    section_core: "Core Features",
    advanced_features: "Advanced Features",
    allowed_modes: "Decision Modes",
    enabled_languages: "Languages",
    mode_selection: "Allow Mode Selection",
    mode_selection_desc: "Users can choose between Conservative / Balanced / Aggressive. If disabled, defaults to Balanced.",
    max_users: "Maximum Users",
    analytics: "Analytics Dashboard",
    analytics_desc: "Access to analytics and insights",
    api_access: "API Access",
    api_access_desc: "Enable API key access for this tenant",
    data_export: "Data Export",
    data_export_desc: "Allow exporting campaign data",
    custom_branding: "Custom Branding",
    custom_branding_desc: "Allow custom logo and colors",
    campaign_decision_toggle_desc: "Enable/disable the entire campaign decision module",
    share_links: "Share Links",
    share_links_desc: "Allow creating and sharing decision links",
    pdf_export_desc: "Enable PDF download for decisions",
    save_all_changes: "Save All Changes",
    saving: "Saving...",

    // ─── Plans ────────────────────────────────────────────────
    plans_title: "Plans & Pricing",
    plans_subtitle: "Choose the perfect plan for your business needs",
    current_plan: "Current Plan",
    current_usage: "Current Usage",
    per_month: "per month",
    this_month: "this month",
    total: "total",
    loading_plans: "Loading plans...",
    plan_upgraded_success: "Successfully upgraded to",
    need_help_choosing: "Need help choosing a plan?",
    free_plan_name: "Free Plan",
    free_plan_desc: "Perfect for testing NexusFlow and evaluating a few campaigns. Great for freelancers and small projects.",
    pro_plan_name: "Pro Plan",
    pro_plan_desc: "Ideal for growing teams managing multiple campaigns. Includes advanced features and higher limits.",
    enterprise_plan_name: "Enterprise Plan",
    enterprise_plan_desc: "Built for large organizations with high-volume needs. Unlimited usage and premium support.",
    questions: "Questions?",
    mvp_manual_billing: "In this MVP version, plan changes are manual. Contact admin to process payment.",
    note: "Note",
    upgrade_required: "Upgrade Required",
    upgrade_to_continue: "Upgrade to Continue",

    // ─── Campaign pages ───────────────────────────────────────
    campaign_decision_ar: "Manage and evaluate your marketing campaigns",
    new_campaign: "New Campaign",
    total_campaigns: "Total Campaigns",
    active_campaigns: "Active Campaigns",
    evaluated_this_month: "Evaluated This Month",
    no_campaigns_yet: "No Campaigns Yet",
    no_campaigns_desc: "Create your first campaign to start tracking and evaluating performance",
    create_first_campaign: "Create Your First Campaign",
    create_campaign: "Create Campaign",
    campaign_name: "Campaign Name",
    campaign_name_placeholder: "e.g., Summer Sale 2024",
    channel: "Channel",
    select_channel: "Select a channel",
    delete_campaign_confirm: "Are you sure you want to delete",
    delete_campaign_warning: "This cannot be undone.",
    campaign_deleted: "has been deleted successfully!",
    campaign_delete_failed: "Failed to delete campaign: ",
    loading_campaigns: "Loading campaigns...",
    back_to_campaigns: "Back to Campaigns",
    campaign_not_found: "Campaign not found",
    loading_campaign: "Loading campaign...",
    evaluate_campaign: "Evaluate Campaign",
    evaluate_this_campaign: "Evaluate This Campaign",
    total_evaluations: "Total Evaluations",
    latest_decision: "Latest Decision",
    decision_history: "Decision History",
    no_evaluations_yet: "No evaluations yet",
    recommended_actions: "Recommended Actions",
    next_review: "Recommended next review",
    days: "days",
    created: "Created",
    tenant_not_found: "Your account is not associated with a tenant. Please contact support.",

    // ─── Evaluate modal ───────────────────────────────────────
    evaluate_campaign_title: "Evaluate Campaign",
    decision_mode: "Decision Mode",
    decision_mode_conservative: "Conservative",
    decision_mode_balanced: "Balanced",
    decision_mode_aggressive: "Aggressive",
    decision_mode_balanced_fixed: "Balanced (Fixed)",
    mode_conservative_desc: "Prioritizes protecting budget. Only continues campaigns with proven strong performance.",
    mode_balanced_desc: "Balanced approach. Weighs both risk and opportunity equally.",
    mode_aggressive_desc: "Growth-focused. More willing to continue campaigns with potential despite current metrics.",
    mode_locked_msg: "Mode selection is not available on your current plan. Upgrade to unlock.",
    evaluation_period: "Evaluation Period (Days)",
    evaluation_period_hint: "Number of days this campaign has been running",
    campaign_metrics: "Campaign Metrics",
    ad_spend: "Ad Spend ",
    ad_spend_placeholder: "e.g., 1500.00",
    revenue: "Revenue Generated ",
    revenue_placeholder: "e.g., 4500.00",
    impressions: "Impressions (Optional)",
    impressions_placeholder: "e.g., 50000",
    clicks: "Clicks (Optional)",
    clicks_placeholder: "e.g., 2500",
    units_sold: "Units Sold (Optional)",
    units_sold_placeholder: "e.g., 120",
    profit_margin: "Profit Margin % (Optional)",
    leads: "Leads Generated",
    conversions: "Conversions (Optional)",
    leads_placeholder: "e.g., 85",
    conversions: "Conversions",
    conversions_placeholder: "e.g., 23",
    run_decision: "Run Decision",
    evaluating: "Evaluating...",
    quota_exceeded_hint: "Monthly evaluation limit reached. Please upgrade your plan.",

    // ─── Decision result ──────────────────────────────────────
    key_performance: "Key Performance Indicators",
    analysis: "Analysis",
    profit: "Profit",
    avg_order_value: "AOV",
    conversion_rate: "Conv. Rate",
    share_decision: "Share Decision",
    share_locked_msg: "Share links are not available on your current plan.",
    pdf_locked_msg: "PDF export is not available on your current plan.",

    // ─── Share modal ──────────────────────────────────────────
    share_decision_desc: "Create a public link to share this result",
    link_expiration: "Link Expiration",
    never_expires: "Never expires",
    link_public_until_expiration: "The link will be publicly accessible until expiration",
    generate_link: "Generate Link",
    generating: "Generating...",
    share_link: "Share Link",
    copied_to_clipboard: "Copied to clipboard!",
    expires_on: "Expires on",
    share_via: "Share this link with",
    check_out_decision: "Check out this campaign decision!",
    done: "Done",
    share_feature_unavailable: "Share feature not available on your plan. Please upgrade.",
    share_limit_reached: "Share link limit reached. Please upgrade your plan.",

    // ─── Usage widget ─────────────────────────────────────────
    usage_this_month: "Usage This Month",
    campaign_evaluations: "Campaign Evaluations",
    unlimited: "Unlimited",
    unlimited_evaluations: "Unlimited evaluations",
    almost_at_limit: "You're almost at your limit! Consider upgrading.",
    approaching_limit: "You're approaching your monthly limit.",
    evaluations_available: "evaluations available this month",
    shares_created: "Shares Created",
    pdfs_generated: "PDFs Generated",
    view_plans: "View Plans",

    // ─── Upgrade CTA ──────────────────────────────────────────
    limit_reached: "Limit Reached",
    not_available_plan: "Not Available",
    almost_at_feature_limit: "Almost at",
    limit_suffix: "Limit",
    remaining_hint: "Upgrade to avoid interruption.",
    upgrade_now: "Upgrade Now",
    not_now: "Not Now",
    recommended_for_you: "Recommended for you:",

    // ─── Products page feature flag ──────────────────────────
products_page_enabled: "Products Page",
products_page_enabled_desc: "Show or hide the Products Intelligence page from the navigation",

    // ─── Public share page ────────────────────────────────────
    share_page_title: "NexusFlow Decision",
    campaign_evaluation_report: "Campaign Evaluation Report",
    get_nexusflow: "Get NexusFlow",
    performance_metrics: "Performance Metrics",
    link_invalid: "This share link is invalid or has expired",
    link_expired: "This share link has expired",
    link_not_available: "Link Not Available",
    loading_decision: "Loading decision...",
    generated_on: "Generated on",
    share_footer_cta: "Want AI-powered campaign decisions for your business?",
    try_nexusflow_free: "Try NexusFlow Free",
  },

  ar: {
    // ─── Brand ───────────────────────────────────────────────
    brand: "نيكسس فلو",

footer_copyright: "© ألفرا. جميع الحقوق محفوظة. الملكية الفكرية مسجلة في المملكة العربية السعودية.",
    // ─── Decision Result labels (DecisionResult.jsx) ──────────
decision_label_continue: "استمر",
decision_label_adjust:   "عدّل",
decision_label_stop:     "أوقف",

status_label_active:      "نشط",
status_label_suspended:   "موقوف",
status_label_critical:    "حرج",
status_label_stable:      "مستقر",
status_label_opportunity: "فرصة",
status_label_warning:     "تحذير",

    // ─── Plan highlights ──────────────────────────────────────
plan_highlight_evals_50: "50 تقييم حملة / شهر",
plan_highlight_evals_500: "500 تقييم حملة / شهر",
plan_highlight_evals_unlimited: "تقييمات غير محدودة",
plan_highlight_campaigns_3: "حتى 3 حملات",
plan_highlight_campaigns_25: "حتى 25 حملة",
plan_highlight_campaigns_unlimited: "حملات غير محدودة",
plan_highlight_shares_10: "10 روابط مشاركة",
plan_highlight_shares_100: "100 رابط مشاركة",
plan_highlight_shares_unlimited: "روابط مشاركة غير محدودة",
plan_highlight_mode_balanced_only: "وضع القرار المتوازن فقط",
plan_highlight_all_modes: "جميع أوضاع القرار",
plan_highlight_pdf_200: "تصدير PDF (200/شهر)",
plan_highlight_pdf_unlimited: "تصدير PDF غير محدود",
plan_highlight_analytics: "لوحة التحليلات",
plan_highlight_api_access: "وصول API",
plan_highlight_custom_branding: "علامة تجارية مخصصة",
plan_highlight_bilingual: "دعم ثنائي اللغة (EN/AR)",
plan_highlight_email_support: "دعم عبر البريد الإلكتروني",
plan_highlight_priority_support: "دعم ذو أولوية",
plan_highlight_account_manager: "مدير حساب مخصص",
free_plan_desc: "مثالي لتجربة NexusFlow",
pro_plan_desc: "للفرق التسويقية المتنامية",
enterprise_plan_desc: "للمؤسسات الكبيرة",

    // ─── Products page feature flag ──────────────────────────
    products_page_enabled: "صفحة المنتجات",
    products_page_enabled_desc: "إظهار أو إخفاء صفحة ذكاء المنتجات من شريط التنقل",


    // ─── Product Dashboard ────────────────────────────────────
    status_critical: "حرج",
    status_opportunity: "فرصة",
    status_stable: "مستقر",
    price_value_high: "مرتفع",
    price_value_medium: "متوسط",
    price_value_low: "منخفض",
    indicator_high: "مرتفع",
    indicator_medium: "متوسط",
    indicator_low: "منخفض",
    rule_reason_low_sales_high_stock: "مبيعات منخفضة مع مخزون مرتفع مما يشير إلى خسارة محتملة",
    rule_reason_high_demand_low_stock: "طلب مرتفع مع مخزون منخفض يُعرّض للنفاد",
    rule_reason_strong_sales_high_price: "مبيعات قوية على الرغم من السعر المرتفع",
    rule_reason_balanced: "توازن بين الطلب والمخزون",
    rule_reason_no_match: "لا توجد قاعدة محددة مطابقة",
    rule_action_reduce_price: "خفّض السعر أو زِد الترويج",
    rule_action_refill_inventory: "أعِد تعبئة المخزون بشكل عاجل",
    rule_action_maintain_price: "حافظ على السعر أو اختبر زيادة طفيفة",
    rule_action_no_action: "لا إجراء مطلوب",

    
    // Arabic (ar)
    role_owner: "مالك",
    role_admin: "مشرف",
    role_manager: "مدير",
    role_member: "عضو",

    decision_continue: "استمرار",
    decision_pause: "إيقاف مؤقت",
    decision_stop: "إيقاف",
    channel_tiktok: "تيك توك",
    channel_snapchat: "سناب شات",
    channel_google: "جوجل",
    channel_meta: "ميتا",
    channel_other: "أخرى",

    plan_free: "مجاني",
    plan_pro: "احترافي",
    plan_enterprise: "المؤسسات",

    // ─── Navigation ────────────────────────────────────────── 
    nav_dashboard: "المنتجات",
    nav_products: "المنتجات",
    nav_campaign_decision: "قرار الحملات",
    nav_admin: "الإدارة",
    nav_logout: "تسجيل الخروج",

    // ─── Language toggle ─────────────────────────────────────
    lang_toggle: "English",
    lang_current: "عربي",

    // ─── Common actions ──────────────────────────────────────
    save: "حفظ",
    cancel: "إلغاء",
    confirm: "تأكيد",
    delete: "حذف",
    edit: "تعديل",
    create: "إنشاء",
    back: "رجوع",
    loading: "جاري التحميل...",
    error: "خطأ",
    success: "تم بنجاح",
    try_again: "حاول مجدداً",
    close: "إغلاق",
    search: "بحث...",
    view: "عرض",
    share: "مشاركة",
    download_pdf: "تحميل PDF",
    upgrade: "ترقية",
    upgrade_plan: "ترقية الخطة",
    not_available: "غير متاح في خطتك الحالية",
    upgrade_to_unlock: "قم بالترقية لفتح هذه الميزة",
    contact_support: "تواصل مع الدعم",
    no_data: "لا توجد بيانات",

    // ─── Status / Decision labels ─────────────────────────────
    status_stable: "مستقر",
    status_opportunity: "فرصة",
    status_critical: "حرج",
    status_warning: "تحذير",
    status_active: "نشط",
    status_suspended: "موقوف",
    status_pending: "بدون تقييم",

    // ─── Profile page ────────────────────────────────────────
    profile_title: "ملفي الشخصي",
    profile_subtitle: "حدّث معلوماتك الشخصية وكلمة المرور",
    profile_personal_info: "المعلومات الشخصية",
    profile_security: "الأمان",
    profile_display_name: "الاسم المعروض",
    profile_email: "البريد الإلكتروني",
    profile_email_locked_hint: "لا يمكن تغيير البريد الإلكتروني حالياً",
    profile_role: "الدور",
    profile_company: "الشركة",
    profile_current_password: "كلمة المرور الحالية",
    profile_new_password: "كلمة المرور الجديدة",
    profile_confirm_password: "تأكيد كلمة المرور الجديدة",
    profile_save: "حفظ التغييرات",
    profile_change_password: "تغيير كلمة المرور",
    profile_password_hint: "اتركه فارغاً للاحتفاظ بكلمة المرور الحالية",
    profile_password_mismatch: "كلمتا المرور غير متطابقتين",
    profile_password_too_short: "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
    profile_saved: "تم تحديث الملف الشخصي بنجاح",
    profile_password_changed: "تم تغيير كلمة المرور بنجاح",
    profile_reauth_required: "يرجى تسجيل الدخول مرة أخرى قبل تغيير كلمة المرور",
    profile_no_changes: "لا توجد تغييرات للحفظ",
    profile_link: "الملف الشخصي",

    // ─── Admin: tenant CRUD ──────────────────────────────────
    admin_add_tenant: "إضافة شركة",
    admin_edit_tenant: "تعديل الشركة",
    admin_delete_tenant: "حذف الشركة",
    admin_tenant_company_name: "اسم الشركة",
    admin_tenant_owner_name: "اسم المالك",
    admin_tenant_owner_email: "بريد المالك الإلكتروني",
    admin_tenant_owner_password: "كلمة المرور الأولية",
    admin_tenant_business_type: "نوع العمل",
    admin_tenant_plan: "الخطة",
    admin_tenant_status: "الحالة",
    admin_create: "إنشاء",
    admin_save: "حفظ",
    admin_cancel: "إلغاء",
    admin_delete_warning: "سيتم حذف الشركة وجميع بياناتها نهائياً — الحملات والقرارات وروابط المشاركة والمستخدمون. لا يمكن التراجع عن هذا الإجراء.",
    admin_delete_confirm_label: "اكتب اسم الشركة للتأكيد",
    admin_tenant_created: "تم إنشاء الشركة بنجاح",
    admin_tenant_updated: "تم تحديث الشركة بنجاح",
    admin_tenant_deleted: "تم حذف الشركة بنجاح",

    decision_continue: "استمر",
    decision_adjust: "عدّل",
    decision_stop: "أوقف",

    // ─── Theme ───────────────────────────────────────────────
    theme_dark: "داكن",
    theme_light: "فاتح",
    view_cards: "بطاقات",
    view_table: "جدول",
    rules_engine_active: "محرك القواعد نشط",

    // ─── Login / Register ─────────────────────────────────────
    sign_in: "تسجيل الدخول",
    register: "إنشاء حساب",
    sign_in_to_account: "سجّل دخولك إلى حسابك",
    create_company_account: "أنشئ حساب شركتك",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    confirm_password: "تأكيد كلمة المرور",
    your_name: "اسمك",
    company_name: "اسم الشركة",
    business_type: "نوع النشاط التجاري",
    business_type_agency: "وكالة تسويق",
    business_type_store: "متجر إلكتروني",
    business_type_service: "شركة خدمات",
    select_business_type: "اختر نوع النشاط...",
    passwords_no_match: "كلمتا المرور غير متطابقتين",
    creating_account: "جاري إنشاء الحساب...",
    signing_in: "جاري تسجيل الدخول...",
    already_have_account: "لديك حساب بالفعل؟",
    no_account_yet: "ليس لديك حساب؟",
    register_company: "سجّل شركتك",
    min_password: "٦ أحرف على الأقل",
    business_type_hint_agency: "تتبّع حملات العملاء والعائد على الاستثمار",
    business_type_hint_store: "راقب المنتجات وهوامش الربح",
    business_type_hint_service: "أدر العملاء المحتملين والتحويلات",
    login_invalid: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    login_not_found: "لا يوجد حساب بهذا البريد الإلكتروني",
    login_failed: "فشل تسجيل الدخول. حاول مجدداً.",
    register_failed: "فشل التسجيل. حاول مجدداً.",

    // ─── Dashboard (Products) ─────────────────────────────────
    dashboard_title: "ذكاء المنتجات",
    dashboard_subtitle: "تحليل المنتجات في الوقت الفعلي",
    performance_overview: "نظرة عامة على الأداء",
    total_products: "إجمالي المنتجات",
    all_time: "كل الأوقات",
    high_growth_potential: "إمكانية نمو عالية",
    requires_attention: "يتطلب اهتماماً",
    filter_all: "الكل",
    filter_stable: "مستقر",
    filter_opportunity: "فرصة",
    filter_critical: "حرج",
    search_products: "ابحث عن منتج...",
    no_products_found: "لا توجد منتجات مطابقة",
    no_products_yet: "لا توجد منتجات",
    confidence: "الثقة",
    action: "الإجراء",
    reason: "السبب",
    avg_confidence: "متوسط الثقة",
    total_sales: "إجمالي المبيعات",
    total_stock: "إجمالي المخزون",
    sales: "المبيعات",
    stock: "المخزون",
    price: "السعر",
    price_high: "مرتفع",
    price_medium: "متوسط",
    price_low: "منخفض",
    sales_high: "مرتفعة",
    sales_medium: "متوسطة",
    sales_low: "منخفضة",
    stock_high: "مرتفع",
    stock_medium: "متوسط",
    stock_low: "منخفض",

    // ─── Usage widget ─────────────────────────────────────────
    usage_this_month: "الاستخدام هذا الشهر",
    campaign_evaluations: "تقييمات الحملات",
    unlimited_evaluations: "تقييمات غير محدودة",
    evaluations_available: "تقييمات متاحة هذا الشهر",
    almost_at_limit: "أوشكت على بلوغ الحد! فكّر في الترقية.",
    approaching_limit: "أنت تقترب من الحد الشهري.",
    view_plans: "عرض الخطط",
    shares_created: "المشاركات المُنشأة",
    pdfs_generated: "ملفات PDF المُولَّدة",

    // ─── Campaign Decision ────────────────────────────────────
    campaign_decision: "قرار الحملة",
    campaign_decision_ar: "قرار الحملة",
    campaigns: "الحملات",
    new_campaign: "حملة جديدة",
    create_campaign: "إنشاء حملة",
    campaign_name: "اسم الحملة",
    campaign_name_placeholder: "مثال: حملة الصيف 2024",
    channel: "القناة",
    select_channel: "اختر قناة",
    specify_channel: "حدد القناة",
    specify_channel_placeholder: "مثال: LinkedIn، X، YouTube...",
    no_campaigns_yet: "لا توجد حملات بعد",
    no_campaigns_desc: "أنشئ أولى حملاتك لبدء التتبع والتقييم",
    create_first_campaign: "أنشئ أولى حملاتك",
    total_campaigns: "إجمالي الحملات",
    active_campaigns: "الحملات النشطة",
    evaluated_this_month: "مُقيَّم هذا الشهر",
    delete_campaign_confirm: "هل أنت متأكد من حذف",
    delete_campaign_warning: "لا يمكن التراجع عن هذا الإجراء.",
    campaign_deleted: "تم حذفه بنجاح!",
    campaign_delete_failed: "فشل حذف الحملة: ",
    evaluations: "التقييمات",
    latest_decision: "آخر قرار",
    created: "تاريخ الإنشاء",
    loading_campaigns: "جاري تحميل الحملات...",

    // ─── Campaign Detail ──────────────────────────────────────
    back_to_campaigns: "العودة إلى الحملات",
    evaluate_campaign: "تقييم الحملة",
    total_evaluations: "إجمالي التقييمات",
    decision_history: "سجل القرارات",
    no_evaluations_yet: "لا توجد تقييمات بعد",
    evaluate_this_campaign: "قيّم هذه الحملة",
    loading_campaign: "جاري تحميل الحملة...",
    campaign_not_found: "الحملة غير موجودة",

    // ─── Evaluate Modal ───────────────────────────────────────
    evaluate_campaign_title: "تقييم الحملة",
    decision_mode: "وضع القرار",
    decision_mode_fixed: "ثابت في خطتك الحالية",
    decision_mode_conservative: "محافظ",
    decision_mode_balanced: "متوازن",
    decision_mode_aggressive: "جريء",
    decision_mode_balanced_fixed: "متوازن (ثابت)",
    mode_conservative_desc: "يُعطي الأولوية لحماية الميزانية. يكمل فقط الحملات ذات الأداء القوي.",
    mode_balanced_desc: "نهج متوازن. يوازن بين المخاطرة والفرصة بالتساوي.",
    mode_aggressive_desc: "يركز على النمو. أكثر استعداداً لمتابعة الحملات ذات الإمكانية.",
    mode_locked_msg: "اختيار الوضع غير متاح في خطتك الحالية.",
    evaluation_period: "فترة التقييم (أيام)",
    evaluation_period_hint: "عدد الأيام التي تعمل فيها الحملة",
    campaign_metrics: "مؤشرات الحملة",
    ad_spend: "الإنفاق الإعلاني ",
    ad_spend_placeholder: "مثال: 1500.00",
    revenue: "الإيرادات المُحققة ",
    revenue_placeholder: "مثال: 4500.00",
    target_roas: "العائد المستهدف (اختياري)",
    impressions: "مرات الظهور (اختياري)",
    impressions_placeholder: "مثال: 50000",
    clicks: "النقرات (اختياري)",
    clicks_placeholder: "مثال: 2500",
    units_sold: "الوحدات المباعة (اختياري)",
    units_sold_placeholder: "مثال: 120",
    profit_margin: "هامش الربح % (اختياري)",
    fees: "الرسوم (اختياري)",
    shipping: "الشحن (اختياري)",
    returns_pct: "نسبة المرتجعات % (اختياري)",
    leads: "العملاء المحتملون",
    conversions: "التحويلات (اختياري)",
    leads_placeholder: "مثال: 85",
    conversions: "التحويلات",
    conversions_placeholder: "مثال: 23",
    conversion_pct: "نسبة التحويل %",
    avg_ticket: "متوسط قيمة الصفقة",
    service_cost: "تكلفة الخدمة (اختياري)",
    run_decision: "تشغيل القرار",
    evaluating: "جاري التقييم...",

    // ─── Decision Result ──────────────────────────────────────
    key_performance: "مؤشرات الأداء الرئيسية",
    analysis: "التحليل",
    recommended_actions: "الإجراءات الموصى بها",
    next_review: "الإعادة الموصى بها:",
    days: "أيام",
    share_decision: "مشاركة القرار",
    share_locked: "روابط المشاركة غير متاحة في خطتك الحالية.",
    pdf_locked: "تصدير PDF غير متاح في خطتك الحالية.",
    share_upgrade_required: "مشاركة (ترقية مطلوبة)",
    pdf_upgrade_required: "PDF (ترقية مطلوبة)",

    // ─── Share Modal ──────────────────────────────────────────
    create_public_link: "أنشئ رابطاً عاماً لمشاركة هذه النتيجة",
    link_expiration: "انتهاء صلاحية الرابط",
    generating: "جاري الإنشاء...",
    generate_link: "إنشاء الرابط",
    share_link: "رابط المشاركة",
    copied: "تم النسخ!",
    expires_on: "ينتهي في:",
    share_with: "شارك هذا الرابط عبر:",
    done: "تم",
    never_expires: "لا ينتهي أبداً",

    // ─── Plans ───────────────────────────────────────────────
    plans_title: "الخطط والأسعار",
    plans_subtitle: "اختر الخطة المناسبة لاحتياجات عملك",
    current_plan_label: "الخطة الحالية",
    current_usage: "الاستخدام الحالي",
    per_month: "/شهر",
    upgrade_to: "ترقية إلى",
    downgrade_to: "تخفيض إلى",
    select_plan: "اختر",
    current_plan: "الخطة الحالية",
    processing: "جاري المعالجة...",
    evaluations_quota: "التقييمات",
    campaigns_quota: "الحملات",
    share_links_quota: "روابط المشاركة",
    pdf_quota: "تصدير PDF",
    unlimited: "غير محدود",
    not_included: "غير مشمول",
    plan_free: "مجاني",
    plan_pro: "برو",
    plan_enterprise: "مؤسسي",
    need_help_plan: "هل تحتاج مساعدة في اختيار الخطة؟",
    free_plan_desc: "مثالي لاختبار نيكسس فلو وتقييم عدد قليل من الحملات.",
    pro_plan_desc: "مثالي للفرق المتنامية التي تدير حملات متعددة.",
    enterprise_plan_desc: "مُصمَّم للمؤسسات الكبيرة ذات الاحتياجات الضخمة.",
    billing_note: "في نسخة MVP هذه، تغييرات الخطة يدوية. تواصل مع الإدارة لمعالجة الدفع.",
    questions: "أسئلة؟",
    most_popular: "الأكثر شيوعاً",
    change_plan_confirm: "هل أنت متأكد من التغيير إلى خطة",
    plan_label: "؟",
    loading_plans: "جاري تحميل الخطط...",

    // ─── Upgrade CTA ─────────────────────────────────────────
    limit_reached: "تم بلوغ الحد",
    not_available_plan: "غير متاح",
    almost_at_feature_limit: "اقتربت من حد",
    limit_suffix: "",
    upgrade_to_continue: "قم بالترقية للمتابعة",
    upgrade_to_unlock: "قم بالترقية لفتح الميزة",
    upgrade_now: "قم بالترقية الآن",
    not_now: "ليس الآن",
    recommended_for_you: "موصى به لك:",
    exceeded: "تجاوزت الحد",
    warning_status: "تحذير",
    quota_exceeded_hint: "تجاوزت الحصة المخصصة. قم بترقية خطتك للمتابعة.",
    remaining_hint: "متبقٍ. فكّر في الترقية.",

    // ─── Admin Dashboard ──────────────────────────────────────
    admin_title: "مدير النظام",
    admin_subtitle: "إدارة نيكسس فلو",
    total_tenants: "إجمالي الشركات",
    total_users: "إجمالي المستخدمين",
    suspended_count: "موقوف",
    tab_tenants: "الشركات",
    tab_users: "المستخدمون",
    col_company: "الشركة",
    col_status: "الحالة",
    col_users: "المستخدمون",
    col_api_key: "مفتاح API",
    col_actions: "الإجراءات",
    col_user: "المستخدم",
    col_role: "الدور",
    no_tenants: "لا توجد شركات. سجّل شركة للبدء.",
    no_users: "لا يوجد مستخدمون.",
    action_suspend: "إيقاف",
    action_activate: "تفعيل",
    action_regen_key: "إعادة توليد مفتاح API",
    action_change_plan: "تغيير الخطة",
    current_plan_prompt: "الخطة الحالية:",
    select_new_plan: "اختر الخطة الجديدة:\n- plan_trial\n- plan_basic\n- plan_pro\n- plan_enterprise\n\nاكتب معرّف الخطة:",
    plan_updated: "تم تحديث الخطة إلى",
    plan_update_failed: "خطأ: ",
    role_owner: "مالك",
    role_admin: "مدير",
    role_manager: "مشرف",
    role_viewer: "مشاهد",
    role_member: "عضو",

    // ─── Tenant Features (Admin) ──────────────────────────────
    tenant_features_title: "إدارة ميزات الشركات",
    tenant_features_subtitle: "إدارة أعلام الميزات وضوابط الوصول لكل شركة",
    select_tenant: "اختر شركة",
    select_tenant_hint: "اختر شركة لإدارة ميزاتها",
    feature_flags: "أعلام الميزات وضوابط الوصول",
    section_core: "الميزات الأساسية",
    section_modes: "أوضاع القرار",
    section_languages: "اللغات",
    section_limits: "الحدود والوصول",
    section_advanced: "الميزات المتقدمة",
    feature_campaign_decision: "وحدة قرار الحملة",
    feature_campaign_decision_desc: "تفعيل/تعطيل وحدة قرار الحملة بالكامل",
    feature_share: "روابط المشاركة",
    feature_share_desc: "السماح بإنشاء ومشاركة روابط القرارات",
    feature_pdf: "تصدير PDF",
    feature_pdf_desc: "تفعيل تحميل PDF للقرارات",
    feature_analytics: "لوحة التحليلات",
    feature_analytics_desc: "الوصول إلى التحليلات والرؤى",
    feature_mode_selection: "السماح باختيار الوضع",
    feature_mode_selection_desc: "يمكن للمستخدمين الاختيار بين المحافظ/المتوازن/الجريء.",
    allowed_modes: "الأوضاع المسموحة",
    enabled_languages: "اللغات المفعّلة",
    max_users: "الحد الأقصى للمستخدمين",
    max_users_hint: "عدد المستخدمين المسموح بهم في هذه الشركة",
    feature_api_access: "الوصول عبر API",
    feature_api_access_desc: "تفعيل الوصول بمفتاح API لهذه الشركة",
    feature_export: "تصدير البيانات",
    feature_export_desc: "السماح بتصدير بيانات الحملات",
    feature_custom_branding: "العلامة التجارية المخصصة",
    feature_custom_branding_desc: "السماح بشعار وألوان مخصصة",
    save_changes: "حفظ التغييرات",
    saving: "جاري الحفظ...",
    save_all: "حفظ جميع التغييرات",
    features_updated: "تم تحديث الميزات بنجاح!",
    features_failed: "فشل حفظ الميزات",
    enabled_label: "مفعّل",
    disabled_label: "معطّل",

    // ─── Public Share ─────────────────────────────────────────
    share_page_title: "قرار نيكسس فلو",
    share_page_subtitle: "تقرير تقييم الحملة",
    get_nexusflow: "احصل على نيكسس فلو",
    link_invalid: "الرابط غير متاح",
    link_invalid_desc: "رابط المشاركة هذا غير صالح أو انتهت صلاحيته",
    link_expired_desc: "انتهت صلاحية رابط المشاركة هذا",
    link_load_failed: "فشل تحميل القرار",
    performance_metrics: "مؤشرات الأداء",
    generated_on: "أُنشئ في",
    try_nexusflow: "هل تريد قرارات حملات مدعومة بالذكاء الاصطناعي لعملك؟",
    try_free: "جرّب نيكسس فلو مجاناً",

    // ─── Feature locked (Campaigns) ──────────────────────────
    campaign_locked_title: "وحدة قرار الحملة غير متاحة",
    campaign_locked_desc: "هذه الميزة القوية غير مشمولة في خطتك الحالية. قم بالترقية لفتح قرارات الحملات المدعومة بالذكاء الاصطناعي.",
    campaign_locked_feature_1: "تحليل أداء الحملات بالذكاء الاصطناعي",
    campaign_locked_feature_2: "توصيات تلقائية: استمر / عدّل / أوقف",
    campaign_locked_feature_3: "تتبع مؤشرات الأداء الرئيسية في الوقت الفعلي",
    campaign_locked_feature_4: "إدارة الحملات متعددة القنوات",
    what_youll_get: "ما ستحصل عليه مع الترقية:",

    // ─── Account suspended ────────────────────────────────────
    account_suspended: "الحساب موقوف",
    account_suspended_desc: "تم إيقاف حساب شركتك. يرجى التواصل مع الدعم للمساعدة.",
    company_label: "الشركة:",

    // ─── Auth / Route guards ──────────────────────────────────
    checking_auth: "جاري التحقق من المصادقة...",
    admin_required: "صلاحية المدير مطلوبة",
    admin_required_desc: "ليس لديك صلاحية للوصول إلى هذه الصفحة.",
    go_to_dashboard: "الذهاب إلى لوحة التحكم",
    loading_user: "جاري تحميل بيانات المستخدم...",
    please_wait: "انتظر من فضلك",
    tenant_not_found: "حسابك غير مرتبط بأي شركة. يرجى التواصل مع الدعم.",

    // ─── Dashboard / Products ─────────────────────────────────
    performance_overview: "نظرة عامة على الأداء",
    performance_summary: "ملخص الأداء",
    based_on_all_metrics: "بناءً على جميع المقاييس",
    total_products: "إجمالي المنتجات",
    all_time: "كل الوقت",
    growth_last_month: "+12% من الشهر الماضي",
    high_growth_potential: "إمكانية نمو عالية",
    requires_attention: "يحتاج اهتماماً",
    ai_prediction_accuracy: "دقة توقعات الذكاء الاصطناعي",
    confidence_low: "منخفض",
    confidence_high: "مرتفع",
    confidence_excellent: "ممتاز",
    confidence_good: "جيد",
    confidence_needs_improvement: "يحتاج تحسيناً",
    confidence_growth: "+3.2% هذا الشهر",
    perf_strong: "قوي",
    perf_moderate: "متوسط",
    perf_weak: "ضعيف",

    // ─── Controls ─────────────────────────────────────────────
    all_products: "جميع المنتجات",
    search_products: "ابحث عن منتج...",

    // ─── Product cards / table ────────────────────────────────
    sales_label: "المبيعات",
    stock_label: "المخزون",
    price_label: "السعر",
    col_product: "المنتج",
    confidence: "ثقة",
    rule_confidence: "ثقة القاعدة",
    recommended_action: "الإجراء الموصى به",
    no_products_found: "لم يتم العثور على منتجات",
    adjust_filters: "جرّب تعديل الفلاتر أو استعلام البحث",
    indicator_high: "مرتفع",
    indicator_medium: "متوسط",
    indicator_low: "منخفض",
    price_high: "مرتفع",
    price_medium: "متوسط",
    price_low: "منخفض",

    // ─── Footer ───────────────────────────────────────────────
    rules_engine_active: "محرك القواعد نشط",
    products_analyzed: "المنتجات المحللة",

    // ─── Plan card ────────────────────────────────────────────
    most_popular: "الأكثر شيوعاً",
    current_plan_badge: "خطتك الحالية",
    month: "شهر",
    upgrade_to: "الترقية إلى",
    downgrade_to: "التخفيض إلى",
    select_plan_btn: "اختيار",
    processing: "جارٍ المعالجة...",
    not_included: "غير مشمول",

    // ─── Usage progress ───────────────────────────────────────
    of: "من",
    quota_exceeded: "تم التجاوز",
    quota_warning: "تحذير",
    quota_exceeded_msg: "تم تجاوز الحصة. قم بترقية خطتك للمتابعة.",
    quota_remaining_msg: "متبقية. فكر في الترقية.",

    // ─── Feature flag toggle ──────────────────────────────────
    feature_enabled: "مفعّل",
    feature_disabled: "معطّل",
plan_free: "مجاني",
plan_pro: "احترافي",
plan_enterprise: "المؤسسي",
role_owner: "مالك",
role_admin: "مدير",
role_manager: "مشرف",
role_member: "عضو",
    // ─── Footer AR ────────────────────────────────────────────
    // ─── Week 2: Company Dashboard ────────────────────────────
    nav_company: "الرئيسية",
    company_dashboard: "لوحة تحكم الشركة",
    welcome_back: "مرحباً بعودتك",
    role_label: "الدور",
    refresh: "تحديث",
    recent_activity: "النشاط الأخير",
    no_recent_activity: "لا توجد قرارات بعد. قم بتشغيل أول تقييم لحملة لترى النشاط هنا.",
    go_to_campaigns: "الذهاب إلى الحملات",
    decision_breakdown: "توزيع القرارات",
    based_on_label: "بناءً على آخر",
    decisions_label: "قرار",
    continue_decisions: "قرارات الاستمرار",
    evaluations_this_month: "التقييمات هذا الشهر",
    last_10_decisions: "من آخر 10 قرارات",
    plan_label: "الخطة",
    total_evals_label: "إجمالي التقييمات",
    of_label: "من",
    active_label: "نشط",
    your_campaigns: "حملاتك",
    more_campaigns: "حملة أخرى",
    view_all: "عرض الكل",
    quick_actions: "الإجراءات السريعة",
    manage_team: "إدارة الفريق",

    // ─── Week 2: Campaigns page fixes ─────────────────────────
    campaigns_subtitle: "تتبع وتقييم وتحسين حملاتك التسويقية",
    campaigns_label: "حملة",
    search_campaigns_placeholder: "ابحث عن الحملات بالاسم...",
    clear_filters: "مسح الفلاتر",
    no_campaigns_match: "لا توجد حملات تطابق الفلاتر الحالية.",
    create_campaign_subtitle: "أنشئ حملة جديدة لبدء تتبع الأداء",
    sort_newest: "الأحدث أولاً",
    sort_oldest: "الأقدم أولاً",
    sort_most_evals: "الأكثر تقييماً",
    sort_last_decision: "آخر قرار",
    all_label: "الكل",
    decision_continue: "استمرار",
    decision_pause: "إيقاف مؤقت",
    decision_stop: "إيقاف",

    // ─── Week 2: Evaluate modal fixes ─────────────────────────
    auto_detected_label: "تم الاكتشاف تلقائياً",
    change_business_type: "تغيير نوع العمل",
    select_business_type_hint: "اختر النوع الذي يصف نموذج عملك بشكل أفضل:",
    error_cost_required: "الإنفاق الإعلاني مطلوب ويجب أن يكون أكبر من صفر.",
    error_revenue_required: "الإيرادات مطلوبة ويجب أن تكون أكبر من صفر.",
    error_leads_conversions_required: "العملاء المحتملون والتحويلات مطلوبان.",
    error_conversions_exceed_leads: "لا يمكن أن تتجاوز التحويلات عدد العملاء المحتملين.",
    roas_formula_hint: "الإيرادات ÷ الإنفاق الإعلاني. عائد 3x يعني 3 ريال سعودية مكتسبة مقابل كل 1 ريال سعودي مُنفق.",
    profit_formula_hint: "الإيرادات × نسبة الهامش% − الإنفاق الإعلاني",
    profit_margin_hint: "أدخل كنسبة مئوية، مثال: 35 لـ 35%",
    cpl_formula_hint: "الإنفاق الإعلاني ÷ العملاء المحتملون. كلما قل كان أفضل.",
    conv_rate_formula_hint: "التحويلات ÷ العملاء المحتملون × 100%",

    // ─── Week 3: Decision Result + History ────────────────────
    history_empty_hint: "شغّل أول تقييم لبدء بناء سجل القرارات.",
    no_history_filter_match: "لا توجد قرارات تطابق الفلتر المحدد.",
    load_more: "تحميل المزيد",
    remaining: "متبقية",
    status_updated: "تم تحديث الحالة",
    key_regenerated: "تم إعادة توليد مفتاح API",

    // ─── Week 3: Admin feature-flag dynamic label keys ─────────
    campaign_decision_enabled: "قرار الحملة",
    share_enabled:             "روابط المشاركة",
    pdf_enabled:               "تصدير PDF",
    analytics_enabled:         "التحليلات",
    decision_mode_enabled:     "وضع القرار",
    api_access_enabled:        "الوصول عبر API",
    export_enabled:            "تصدير البيانات",
    custom_branding_enabled:   "علامة تجارية مخصصة",

    // ─── Week 3: misc ─────────────────────────────────────────
    all:    "الكل",
    active: "نشط",

    // ─── Week 4: Roles ────────────────────────────────────────
    role_superadmin:    "مدير النظام",
    change_role:        "تغيير الدور",
    role_changed:       "تم تحديث الدور بنجاح",
    permission_denied:  "وصول مرفوض",
    back_to_dashboard:  "العودة إلى لوحة التحكم",
    viewer_no_access:   "ليس لديك صلاحية للوصول إلى هذه الصفحة.",

    // ─── Week 4: PDF ──────────────────────────────────────────
    generating_pdf:     "جارٍ الإنشاء…",
    pdf_error:          "فشل إنشاء PDF. يرجى المحاولة مرة أخرى.",

    // ─── Footer AR ────────────────────────────────────────────
    footer_powered: "مدعوم من نيكسس فلو",
    footer_rules: "تحليل بالقواعد الذكية",
    footer_realtime: "رؤى لحظية",
    footer_decisions: "قرارات ذكية",

    // ─── Admin ────────────────────────────────────────────────
    admin_title: "لوحة تحكم النظام",
    tenants: "الشركات",
    users: "المستخدمون",
    user: "مستخدم",
    role: "الدور",
    total_tenants: "إجمالي الشركات",
    total_users: "إجمالي المستخدمين",
    suspended: "موقوف",
    activate: "تفعيل",
    suspend: "إيقاف",
    col_company: "الشركة",
    col_status: "الحالة",
    col_actions: "الإجراءات",
    no_tenants: "لا يوجد مستأجرون. سجّل شركة للبدء.",
    no_users: "لا يوجد مستخدمون.",
    regenerate_key: "إعادة توليد مفتاح API",
    change_plan: "تغيير الخطة",
    confirm_plan_change: "هل أنت متأكد من تغيير الخطة إلى",
    type_plan_id: "اكتب معرف الخطة",
    select_plan: "اختر خطة جديدة",

    // ─── Tenant Features ──────────────────────────────────────
    tenant_features: "إعدادات الشركات",
    tenant_features_desc: "تحكم بالمميزات المفعّلة لكل مستأجر",
    feature_flags: "مفاتيح المميزات وصلاحيات الوصول",
    features_saved: "تم تحديث المميزات بنجاح!",
    select_tenant_prompt: "اختر مستأجراً من القائمة لإدارة مميزاته",
    section_core: "المميزات الأساسية",
    advanced_features: "المميزات المتقدمة",
    allowed_modes: "أوضاع القرار",
    enabled_languages: "اللغات المفعّلة",
    mode_selection: "السماح باختيار الوضع",
    mode_selection_desc: "يستطيع المستخدمون الاختيار بين المحافظ / المتوازن / العدواني. إذا أُوقف، يعمل بالوضع المتوازن.",
    max_users: "الحد الأقصى للمستخدمين",
    analytics: "لوحة التحليلات",
    analytics_desc: "الوصول إلى التحليلات والرؤى",
    api_access: "وصول API",
    api_access_desc: "تفعيل وصول مفتاح API لهذالشركات",
    data_export: "تصدير البيانات",
    data_export_desc: "السماح بتصدير بيانات الحملات",
    custom_branding: "تخصيص الهوية البصرية",
    custom_branding_desc: "السماح بشعار وألوان مخصصة",
    campaign_decision_toggle_desc: "تفعيل/إيقاف وحدة قرار الحملة بالكامل",
    share_links: "روابط المشاركة",
    share_links_desc: "السماح بإنشاء ومشاركة روابط القرارات",
    pdf_export_desc: "تفعيل تنزيل PDF للقرارات",
    save_all_changes: "حفظ جميع التغييرات",
    saving: "جارٍ الحفظ...",

    // ─── Plans ────────────────────────────────────────────────
    plans_title: "الخطط والأسعار",
    plans_subtitle: "اختر الخطة المناسبة لاحتياجات عملك",
    current_plan: "الخطة الحالية",
    current_usage: "الاستخدام الحالي",
    per_month: "/ شهر",
    this_month: "هذا الشهر",
    total: "إجمالي",
    loading_plans: "جارٍ تحميل الخطط...",
    plan_upgraded_success: "تمت الترقية بنجاح إلى",
    need_help_choosing: "تحتاج مساعدة في الاختيار؟",
    free_plan_name: "الخطة المجانية",
    free_plan_desc: "مثالية لتجربة NexusFlow وتقييم بعض الحملات. مناسبة للمستقلين والمشاريع الصغيرة.",
    pro_plan_name: "خطة Pro",
    pro_plan_desc: "مثالية للفرق المتنامية التي تدير حملات متعددة. تشمل مميزات متقدمة وحدوداً أعلى.",
    enterprise_plan_name: "خطة Enterprise",
    enterprise_plan_desc: "مصممة للمؤسسات الكبيرة ذات الاحتياجات العالية. استخدام غير محدود ودعم متميز.",
    questions: "أسئلة؟",
    mvp_manual_billing: "في هذا الإصدار، تغييرات الخطط يدوية. تواصل مع المسؤول لإتمام الدفع.",
    note: "ملاحظة",
    upgrade_required: "ترقية مطلوبة",
    upgrade_to_continue: "قم بالترقية للمتابعة",

    // ─── Campaign pages ───────────────────────────────────────
    campaign_decision_ar: "إدارة وتقييم حملاتك التسويقية",
    new_campaign: "حملة جديدة",
    total_campaigns: "إجمالي الحملات",
    active_campaigns: "الحملات النشطة",
    evaluated_this_month: "المُقيَّمة هذا الشهر",
    no_campaigns_yet: "لا توجد حملات بعد",
    no_campaigns_desc: "أنشئ حملتك الأولى لبدء تتبع الأداء وتقييمه",
    create_first_campaign: "إنشاء حملتك الأولى",
    create_campaign: "إنشاء حملة",
    campaign_name: "اسم الحملة",
    campaign_name_placeholder: "مثال: حملة الصيف 2024",
    channel: "القناة",
    select_channel: "اختر قناة",
    delete_campaign_confirm: "هل أنت متأكد من حذف",
    delete_campaign_warning: "لا يمكن التراجع عن هذا.",
    campaign_deleted: "تم حذفها بنجاح!",
    campaign_delete_failed: "فشل حذف الحملة: ",
    loading_campaigns: "جارٍ تحميل الحملات...",
    back_to_campaigns: "العودة إلى الحملات",
    campaign_not_found: "الحملة غير موجودة",
    loading_campaign: "جارٍ تحميل الحملة...",
    evaluate_campaign: "تقييم الحملة",
    evaluate_this_campaign: "تقييم هذه الحملة",
    total_evaluations: "إجمالي التقييمات",
    latest_decision: "آخر قرار",
    decision_history: "سجل القرارات",
    no_evaluations_yet: "لا توجد تقييمات بعد",
    recommended_actions: "الإجراءات الموصى بها",
    next_review: "المراجعة التالية الموصى بها",
    days: "أيام",
    created: "تاريخ الإنشاء",
    tenant_not_found: "حسابك غير مرتبط بمستأجر. يرجى التواصل مع الدعم.",

    // ─── Evaluate modal ───────────────────────────────────────
    evaluate_campaign_title: "تقييم الحملة",
    decision_mode: "وضع القرار",
    decision_mode_conservative: "محافظ",
    decision_mode_balanced: "متوازن",
    decision_mode_aggressive: "عدواني",
    decision_mode_balanced_fixed: "متوازن (ثابت)",
    mode_conservative_desc: "يعطي الأولوية لحماية الميزانية. يستمر فقط مع الحملات ذات الأداء المثبت.",
    mode_balanced_desc: "نهج متوازن. يزن المخاطر والفرص بالتساوي.",
    mode_aggressive_desc: "يركز على النمو. أكثر استعداداً للاستمرار رغم المقاييس الحالية.",
    mode_locked_msg: "اختيار الوضع غير متاح في خطتك الحالية. قم بالترقية للتفعيل.",
    evaluation_period: "فترة التقييم (أيام)",
    evaluation_period_hint: "عدد الأيام التي كانت الحملة تعمل فيها",
    campaign_metrics: "مقاييس الحملة",
    ad_spend: "الإنفاق الإعلاني ",
    ad_spend_placeholder: "مثال: 1500.00",
    revenue: "الإيرادات المحققة ",
    revenue_placeholder: "مثال: 4500.00",
    impressions: "مرات الظهور (اختياري)",
    impressions_placeholder: "مثال: 50000",
    clicks: "النقرات (اختياري)",
    clicks_placeholder: "مثال: 2500",
    units_sold: "الوحدات المباعة (اختياري)",
    units_sold_placeholder: "مثال: 120",
    profit_margin: "هامش الربح % (اختياري)",
    leads: "العملاء المحتملون",
    conversions: "التحويلات (اختياري)",
    leads_placeholder: "مثال: 85",
    conversions: "التحويلات",
    conversions_placeholder: "مثال: 23",
    run_decision: "تشغيل القرار",
    evaluating: "جارٍ التقييم...",
    quota_exceeded_hint: "تم الوصول إلى الحد الشهري للتقييمات. يرجى ترقية خطتك.",

    // ─── Decision result ──────────────────────────────────────
    key_performance: "مؤشرات الأداء الرئيسية",
    analysis: "التحليل",
    profit: "الربح",
    avg_order_value: "متوسط قيمة الطلب",
    conversion_rate: "معدل التحويل",
    share_decision: "مشاركة القرار",
    share_locked_msg: "روابط المشاركة غير متوفرة في خطتك الحالية.",
    pdf_locked_msg: "تصدير PDF غير متوفر في خطتك الحالية.",

    // ─── Share modal ──────────────────────────────────────────
    share_decision_desc: "أنشئ رابطاً عاماً لمشاركة هذه النتيجة",
    link_expiration: "انتهاء صلاحية الرابط",
    never_expires: "لا تنتهي صلاحيته أبداً",
    link_public_until_expiration: "سيكون الرابط متاحاً للعموم حتى تاريخ انتهاء الصلاحية",
    generate_link: "إنشاء رابط",
    generating: "جارٍ الإنشاء...",
    share_link: "رابط المشاركة",
    copied_to_clipboard: "تم النسخ!",
    expires_on: "تنتهي الصلاحية في",
    share_via: "شارك هذا الرابط عبر",
    check_out_decision: "اطّلع على قرار الحملة هذا!",
    done: "تم",
    share_feature_unavailable: "ميزة المشاركة غير متوفرة في خطتك. يرجى الترقية.",
    share_limit_reached: "تم الوصول إلى حد روابط المشاركة. يرجى ترقية خطتك.",

    // ─── Usage widget ─────────────────────────────────────────
    usage_this_month: "الاستخدام هذا الشهر",
    campaign_evaluations: "تقييمات الحملات",
    unlimited: "غير محدود",
    unlimited_evaluations: "تقييمات غير محدودة",
    almost_at_limit: "أنت على وشك بلوغ الحد! فكر في الترقية.",
    approaching_limit: "أنت تقترب من حدك الشهري.",
    evaluations_available: "تقييم متاح هذا الشهر",
    shares_created: "المشاركات ",
    pdfs_generated: "ملفات PDF ",
    view_plans: "عرض الخطط",

    // ─── Upgrade CTA ──────────────────────────────────────────
    limit_reached: "تم بلوغ الحد",
    not_available_plan: "غير متاح",
    almost_at_feature_limit: "على وشك بلوغ حد",
    limit_suffix: "",
    remaining_hint: "قم بالترقية لتجنب الانقطاع.",
    upgrade_now: "ترقية الآن",
    not_now: "ليس الآن",
    recommended_for_you: "موصى به لك:",

    // ─── Public share page ────────────────────────────────────
    share_page_title: "قرار NexusFlow",
    campaign_evaluation_report: "تقرير تقييم الحملة",
    get_nexusflow: "احصل على NexusFlow",
    performance_metrics: "مقاييس الأداء",
    link_invalid: "رابط المشاركة غير صالح أو انتهت صلاحيته",
    link_expired: "انتهت صلاحية رابط المشاركة",
    link_not_available: "الرابط غير متاح",
    loading_decision: "جارٍ تحميل القرار...",
    generated_on: "تم الإنشاء في",
    share_footer_cta: "هل تريد قرارات حملة مدعومة بالذكاء الاصطناعي لعملك؟",
    try_nexusflow_free: "جرّب NexusFlow مجاناً",
  },
};

export default translations;